// ----------------------------------------------------------------------------
// Функция возвращает куки с указанным name, или undefined, если ничего не найдено
// ----------------------------------------------------------------------------



const getCookie = function (name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export default getCookie;